export const HOME_DELIVERY = 'Despacho a domicilio'

export const PICKUP_POINT = 'Retiro en Punto'

export const LOCAL_PICKUP = 'Retiro en Tienda'
